import { render, staticRenderFns } from "./exhibitor-list-mixin.vue?vue&type=template&id=60265108&scoped=true"
import script from "./exhibitor-list-mixin.vue?vue&type=script&lang=js"
export * from "./exhibitor-list-mixin.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-list-mixin.vue?vue&type=style&index=0&id=60265108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60265108",
  null
  
)

export default component.exports